import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  matchesHeader: {
    display: "flex",
    alignItems: "center",
    margin: "7px 0 0"
  },
  matchesHeaderText: {
    display: "flex",
    alignItems: "center",
    fontSize: 12,
    position: "relative",
    top: 1
  },
  horsesNamesList: {
    display: "flex",
    flexWrap: "wrap",
    marginLeft: 2
  },
  matchesType: {
    display: "flex",
    alignItems: "center",
    marginTop: 8
  },
  horseName: {
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    fontSize: 12,
    color: "#333d40",
    textDecoration: "underline",
    cursor: "pointer"
  },
  lastRaceIconDetails: {
    width: 32,
    height: 13,
    color: "#48769b",
    position: "relative",
    left: -4
  },
  customIconDetails: {
    width: 32,
    height: 17,
    color: "#998765",
    position: "relative",
    left: -4
  }
}));
